
import React from "react";
import { CheckBox, ImageUpload, TextArea, TextField } from "../controllers/addDemandcontrollers";
import { ErrorMessage, useFormikContext } from "formik";
import Asterisk from "../../../../../components/asterisk/Asterisk";
import { FieldWrapper } from "../../../../../components/Section/Section";
import { FormFieldLabel as Label, FormErrorLabel as ErrorLabel, } from "../../../../../components/label/Labels";
import styles from './demandForms.module.css'
import { CHECKBOX_OPTIONS, NETWORK_TYPES } from "../demandHelper";

const SigtranFields = React.memo(({ index }) => {
    const { values, setFieldValue } = useFormikContext();
    return (
        <>
            <React.Fragment>
                <Label text={"Select Category"} /><Asterisk />
                <FieldWrapper>
                    <div className={styles.checkboxalign}>
                        {/* <CheckBox
                            name={`info.${index}.checkBox`}
                            value="On-Net" />
                        <CheckBox
                            name={`info.${index}.checkBox`}
                            value="Off-Net" />
                        <CheckBox
                            name={`info.${index}.checkBox`}
                            value="ANSI" /> */}
                        {NETWORK_TYPES?.map(option => (
                            <CheckBox
                                key={option.value}
                                name={`info.${index}.checkBox`}
                                value={option.value}
                                label={option.label}
                            />
                        ))}
                    </div>
                    <ErrorMessage name={`info.${index}.checkBox`}>
                        {(msg) => <ErrorLabel text={msg} />}
                    </ErrorMessage>
                </FieldWrapper>
                <TextField
                    label="Avg Monthly MSU Volumes"
                    name={`info.${index}.avg_monthly_msu_volumes`}
                    type="text"
                    placeholder="Avg Monthly MSU Volumes"
                />
                <TextField
                    label="Top Destinations"
                    name={`info.${index}.top_destinations`}
                    type="text"
                    placeholder="Top Destinations"
                />
            </React.Fragment>
            <div className="flex-item">
                <TextArea
                    label={"Additional Information"}
                    id="description"
                    name={`info.${index}.comment`}
                    placeholder="Optional notes..."
                    rows={3}
                    maxlength={`${values?.info?.[index]?.comment?.length}/1000 characters`}
                />
            </div>
            <ImageUpload
                label="Supporting Attachments"
                optional={false}
                name={`info.${index}.files`}
                value={values.info[index].files}
                setFieldValue={setFieldValue}
                displayMessage={"Upload limit: Up to 3 files, max 5 MB each."}
                maxFileSize={5 * 1024 * 1024}
                maxFileSizeTXT={"5MB"}
                combineFilesMaxSize={15 * 1024 * 1024}
                combineFilesMaxSizeTXT={"Combined file size exceeds the 15MB limit"}
                numOfFilesAllowToUpload={3}
                errorMessageForNumberOfFiles={"You can upload max 3 files."}
                acceptFileType={
                    {    
                    'image/*': ['.jpeg','.png',],
                    'application/pdf': ['.pdf'],
                    'application/vnd.ms-excel': ['.xls',],
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
                    'application/msword':['.doc'],
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
                    }
                }
            />
        </>
    );
});

export default SigtranFields;
